import { Link } from 'react-router-dom';
import { LEGAL_DOCS, LEGAL_VERSION } from '../legal/content';

const LegalFooter = () => {
  return (
    <footer className="border-t border-white/10 bg-black/60 backdrop-blur-md text-white relative z-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="text-2xl font-extrabold tracking-tight mb-2" style={{ letterSpacing: '-0.03em' }}>
              Fan<span style={{ background: 'linear-gradient(90deg,#f472b6,#c084fc,#22d3ee)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Zingy</span>
            </div>
            <p className="text-[11px] text-white/70 leading-relaxed font-light mb-2">
              Marketplace for film investment, discovery, and the fraternity that powers it. Funds flow through an RBI-registered Partner NBFC.
            </p>
            <p className="text-[10px] text-white/70 font-mono">v{LEGAL_VERSION}</p>
          </div>
          {/* Product */}
          <div>
            <div className="text-[11px] uppercase tracking-wider text-white/70 font-bold mb-3">Platform</div>
            <ul className="space-y-2 text-xs text-white/70">
              <li><Link to="/marketplace" className="hover:text-white">Marketplace</Link></li>
              <li><Link to="/fraternity" className="hover:text-white">Fraternity</Link></li>
              <li><Link to="/community" className="hover:text-white">Community</Link></li>
              <li><Link to="/legal/fees" className="hover:text-white">Platform fees</Link></li>
            </ul>
          </div>
          {/* Legal */}
          <div>
            <div className="text-[11px] uppercase tracking-wider text-white/70 font-bold mb-3">Legal</div>
            <ul className="space-y-2 text-xs text-white/70" data-testid="footer-legal-links">
              {LEGAL_DOCS.slice(0, 6).map((d) => (
                <li key={d.slug}>
                  <Link to={`/legal/${d.slug}`} data-testid={`footer-link-${d.slug}`} className="hover:text-white">
                    {d.title.replace(' Policy', '').replace(' & User Agreement', '').replace(' Disclosure', '')}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/legal" className="hover:text-white font-bold">All policies →</Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div>
            <div className="text-[11px] uppercase tracking-wider text-white/70 font-bold mb-3">Contact</div>
            <ul className="space-y-2 text-xs text-white/70">
              <li><a href="mailto:hello@fanzingy.com" className="hover:text-white">hello@fanzingy.com</a></li>
              <li><a href="mailto:grievance@fanzingy.com" className="hover:text-white">grievance@fanzingy.com</a></li>
              <li><a href="mailto:privacy@fanzingy.com" className="hover:text-white">privacy@fanzingy.com</a></li>
              <li><a href="mailto:copyright@fanzingy.com" className="hover:text-white">copyright@fanzingy.com</a></li>
            </ul>
          </div>
        </div>

        {/* Marketplace disclosure */}
        <div className="text-[10px] sm:text-[11px] text-white/70 leading-relaxed font-light border-t border-white/8 pt-6 space-y-2">
          <p>
            <strong className="text-white/60">Marketplace, not a fund.</strong> Fanzingy Technologies Private Limited operates a discovery and introduction marketplace. Fanzingy does NOT pool, custody, manage, or invest money. All capital flows through and is held by a Reserve Bank of India-registered Non-Banking Financial Company partner that contracts directly with each producer and operates the project-specific escrow account.
          </p>
          <p>
            <strong className="text-white/60">Film investments are subject to risk.</strong> Returns are not guaranteed. Past performance does not predict future performance. Nothing on this site is investment advice. Read the <Link to="/legal/risk" className="text-[#c084fc] underline underline-offset-2">Risk Disclosure</Link> for the full picture.
          </p>
          <p className="text-white/70">
            © {new Date().getFullYear()} Fanzingy Technologies Private Limited. All rights reserved.
            Operating in India under PMLA, DPDPA, FEMA, Companies Act, GST and CBFC frameworks. Operating in the United States in accordance with FinCEN, OFAC, SEC Reg D/Reg CF/Reg A+ and state consumer-protection laws.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
